<template>
  <div class="card-wrapper">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      :autoHeight="autoHeight"
      :height="height"
      @reload="getData"
      @openEdit="openEdit"
      @checkbox-change="(data) => $emit('checkbox-change', data)"
    >
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="onHandlePaginationChange"
      />
    </PageMain>

    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      :selectionCode="editOptions.selectionCode"
      :expoMeetingCode="expoMeetingCode"
      :expoInfoCode="expoInfoCode"
      :meetingTaskNode="meetingTaskNode"
      @reload="getData"
    />
    <EditPostMeetingForm
      :visible.sync="editOptions.visiblePostMeeting"
      :type="editOptions.type"
      :selectionCode="editOptions.selectionCode"
      :expoMeetingCode="expoMeetingCode"
      :expoInfoCode="expoInfoCode"
      :meetingTaskNode="meetingTaskNode"
      @reload="getData"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import EditForm from '../edit-task'
import EditPostMeetingForm from '../edit-post-meeting-task'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, EditForm, EditPostMeetingForm },
  props: {
    expoMeetingCode: { type: String, default: '' },
    expoInfoCode: { type: String, default: '' },
    meetingTaskNode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
        autoHeight: { type: Boolean, default: false },
    height: { type: Number, default: 0 },
  },
  data() {
    return {
      usePage: true,
      localTimeZone: '',
      editOptions: {
        visible: false,
        selectionCode: '',
        visiblePostMeeting: false,
      },
      chooseTemplateOptions: { visible: false, params: {} },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData(form = {}) {
      if (!this.expoMeetingCode) return
      this.loading = true
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoTskInfoListApi({
          ...form,
          ...this.page,
          expoMeetingCode: this.expoMeetingCode,
          meetingTaskNode: this.meetingTaskNode,
          localTimeZone,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
    addTask() {
      this.editOptions = {
        visible: true,
        type: 'add',
        visiblePostMeeting: false,
      }
    },
    addPostMeetingTask() {
      this.editOptions = {
        visiblePostMeeting: true,
        type: 'add',
        visible: false,
      }
    },
    async onHandlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      await this.getData()
    },
    openEdit({ type, data = {} }) {
      const { selectionCode } = data
      this.editOptions = { visible: true, type, selectionCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
.card-wrapper {
  background-color: #ffffff;
  border-radius: 6px;
}
</style>
